import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Home from './pages/home';
import Featured from './pages/featured';
import Women from './pages/women';
import Men from './pages/men';
import Search from './pages/search';
import Insights from './pages/insights';
import Brands from './pages/brands';
import Likes from './pages/likes';
import Sale from './pages/on_sale';
import About from './pages/about';
import Footer from './utils/footer';
import LoadingScreen from './utils/loadingState';
import { constantStyles } from './constants/constantStyles';
import ProtectedRoute from './auth/ProtectedRoute';

// Lazy load admin routes (code splitting for better performance)
const StaleProducts = lazy(() => import('./pages/admin/stale'));
const AdminDashboard = lazy(() => import('./pages/admin/dashboard'));
const HomeImages = lazy(() => import('./pages/admin/homeImages'));
const BannerManagement = lazy(() => import('./pages/admin/banners'));

function App() {
  return (
      <div style={{ lineHeight: 1 }}>
        <div style={styles.ContentWrapper}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/featured" element={<Featured />} />
          <Route path="/women" element={<Women />} />
          <Route path="/men" element={<Men />} />
          <Route path="/search" element={<Search />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/sale" element={<Sale /> } />
          <Route path="/likes" element={<Likes />} />
          <Route path="/info" element={<About />} />

          {/* Admin-only routes (lazy loaded for performance) */}
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <AdminDashboard />
              </Suspense>
            </ProtectedRoute>
          } />
          <Route path="/admin/stale" element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <StaleProducts />
              </Suspense>
            </ProtectedRoute>
          } />
          <Route path="/admin/home-images" element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <HomeImages />
              </Suspense>
            </ProtectedRoute>
          } />
          <Route path="/admin/banners" element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <BannerManagement />
              </Suspense>
            </ProtectedRoute>
          } />
        </Routes>
        </div>
      <Footer />
      </div>
  );
}
const styles = {
  ContentWrapper: {
    minHeight: constantStyles.minPageHeight,
  },
};

export default App;
